import React from 'react';
import HipaaLogo from '@assets/hipaa-logo.svg?react';
import { Box, Typography } from '@mui/material';

import { useThemeContext } from '../../../context/theme/context';

export const EnterpriseTrialEndedView: React.FC = () => {
  const { brandLanguage } = useThemeContext();

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#ffffff',
        px: 3,
        py: 6,
      }}
    >
      <Box
        sx={{
          maxWidth: '600px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3,
          textAlign: 'center',
        }}
      >
        <Typography variant="h3" component="h1" sx={{ fontWeight: 600, mb: 2 }}>
          Your trial has ended
        </Typography>

        <Typography variant="body1" sx={{ fontSize: '1.125rem', lineHeight: 1.7, mb: 1 }}>
          Access to {brandLanguage.brandName} is managed by your practice.
        </Typography>

        <Typography variant="body1" sx={{ fontSize: '1.125rem', lineHeight: 1.7, mb: 2 }}>
          Please contact your practice administrator to restore access.
        </Typography>

        <Typography
          variant="body2"
          sx={{
            fontSize: '1rem',
            lineHeight: 1.6,
            color: 'text.secondary',
            fontStyle: 'italic',
            mt: 2,
          }}
        >
          Your notes are safe and will be available once access is restored.
        </Typography>

        <Box sx={{ mt: 6 }}>
          <HipaaLogo height={43} fill="#C8ADE1" aria-label="HIPAA Compliant" />
        </Box>
      </Box>
    </Box>
  );
};
